import { render } from "./GroupSelector.vue?vue&type=template&id=cd84f0b4"
import script from "./GroupSelector.vue?vue&type=script&lang=js"
export * from "./GroupSelector.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__